import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { filter, Subscription } from 'rxjs';

import { Mention } from '../../models/mention';
import { EntityType } from '../../../../api/targeting/enum/entity.type.enum';
import { MediaTypeEnum } from '../../../Basic/enums/media-type.enum';
import { LinkedinSubTypeEnum } from '../../../Basic/enums/linkedin-sub-type.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

import { CurrentUserStateService, TargetingAccessLevel } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { TranslateMentionsService } from '../../../Mentions/services/translate-mentions.service';

@Component({
    selector: 'agpr-coverage-insight-mention-card',
    templateUrl: './coverage-insight-mention-card.component.html',
    styleUrls: ['./coverage-insight-mention-card.component.scss'],
    standalone: false
})

export class CoverageInsightMentionCardComponent implements OnInit {

    @Input() mention: Mention;
    @Input() index?: number;

    @Output() mentionSelectChange = new EventEmitter<void>();
    @Output() outletClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() contactClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() manageMention: EventEmitter<void> = new EventEmitter<void>();
    @Output() viewMention: EventEmitter<void> = new EventEmitter<void>();

    isLegacyTargetingUser: boolean = false;
    subscriptions: Subscription[] = [];
    mentionBody: string = '';

    userLanguage: string;
    concurrentTranslation: number = 0;
    openAiPermission: boolean = false;

    readonly id = 'coverageInsightMentionCard';
    readonly entityTypeEnum = EntityType;
    readonly mediaTypeEnum = MediaTypeEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly linkedinTypeEnum = LinkedinSubTypeEnum;
    readonly maxConcurrentTranslation: number = 3;

    constructor(
        protected currentUserStateService: CurrentUserStateService,
        protected translateService: TranslateMentionsService,
    ) { }

    toggleSelect(): void {
        this.mentionSelectChange.next();
    }

    ngOnInit() {
        this.subscriptions.push(
            this.currentUserStateService.getTargetingAccessLevel().subscribe(x => {
                this.isLegacyTargetingUser = x === TargetingAccessLevel.CLASSIC_ONLY;
            }),
            this.currentUserStateService.getPermissions().pipe(filter(x => !!x)).subscribe(permissions => {
                if (permissions?.length) {
                    this.openAiPermission = permissions.includes(userPermissionsEnum.openAI);
                }
            }),
            this.translateService.getLanguage().subscribe((language) => this.userLanguage = language),
            this.translateService.getConcurrentTranslation().subscribe((concurrentTranslation) => {
                this.concurrentTranslation = concurrentTranslation;
            }),
        );

        if (this.mention.summary) {
            this.mentionBody = this.mention.summary;
        } else {
            this.mentionBody = this.mention.body.slice();
        }
    }

    outletClick(event) {
        this.outletClicked.next();
        event.stopPropagation();
    }

    contactClick(event) {
        this.contactClicked.next();
        event.stopPropagation();
    }

    preventPropagation(event) {
        event.stopPropagation();
    }

    translate() {
        if (this.concurrentTranslation < this.maxConcurrentTranslation) {
            this.translateService.setupChatAI(this.mention, null, true, true);
        }
    }

    revertTranslate(mention: Mention) {
        if (this.concurrentTranslation < this.maxConcurrentTranslation) {
            this.translateService.setDefaultTextAlign(mention);
            mention.showTranslated = false;
            mention.translation = null;
        }
    }
}
